import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acb-alcon-edit-claim-review',
  templateUrl: './edit-claim-review.component.html',
  styleUrls: ['./edit-claim-review.component.scss']
})
export class EditClaimReviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
